const GENERIC_FORM_BUSINESS_MODULES = {
  1: "AssetModule",
  9: "UnitValModule",
  10: "PortfolioModule",
};

export default {
  getKeyModuleByFormId: function (formId) {
    return GENERIC_FORM_BUSINESS_MODULES[formId];
  },
  getInternalFieldMatches(string) {
    const wholeWordRegex = /[a-zA-Z0-9]+[a-zA-Z][a-zA-Z0-9]+/gm;
    const matches = [];
    let m;

    while ((m = wholeWordRegex.exec(string)) !== null) {
      // This is necessary to avoid infinite loops with zero-width matches
      if (m.index === wholeWordRegex.lastIndex) {
        wholeWordRegex.lastIndex++;
      }

      // The result can be accessed through the `m`-variable.
      m.forEach((match, groupIndex) => {
        // console.log(`Found match, group ${groupIndex}: ${match}`);
        if (match != "null") matches.push(match);
      });
    }

    return matches;
  },
  setExplicitWidthToVueMultiselect(doc) {
    var objs = doc.getElementsByClassName("multiselect");
    for (var i = 0; i < objs.length; i++) {
      var eltoWitdh =
        document.getElementsByClassName("multiselect")[i].offsetWidth;
      doc.getElementsByClassName("multiselect__content-wrapper")[
        i
      ].style.width = eltoWitdh + "px";
    }
  },
};
